import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  InvoiceResult,
  UninvoicedPayment,
  uninvoicedPaymentsService,
} from "src/services/uninvoicedPaymentsService";
import { keys } from "./keys";

export const useUninvoicedPayments = () =>
  useQuery<UninvoicedPayment[]>({
    queryKey: keys.admin.uninvoicedPayments(),
    queryFn: () => uninvoicedPaymentsService.getUninvoiced(),
  });

/**
 * Invoicing returns a per-payment result, and the page used to reconcile that
 * against its local array by hand. Invalidating instead means the list comes
 * back from the server as the source of truth, while the returned results are
 * still available to the caller for the success/failure summary.
 */
export const useInvoicePayments = () => {
  const queryClient = useQueryClient();
  return useMutation<{ results: InvoiceResult[] }, unknown, number[] | undefined>({
    mutationFn: (paymentIds) => uninvoicedPaymentsService.invoicePayments(paymentIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.admin.uninvoicedPayments() });
    },
  });
};
